import MPASuperAdminUserDetails from './MPASuperAdminUserDetails';

export default MPASuperAdminUserDetails;
